import { INBOX_DESTINATION } from "./NavigationRegistry";

const INBOX_MENU_ITEM = Object.freeze({
  key: INBOX_DESTINATION.id,
  label: INBOX_DESTINATION.label,
  to: INBOX_DESTINATION.route,
  icon: INBOX_DESTINATION.icon,
  badgeKey: INBOX_DESTINATION.badgeKey,
});

export const HEADER_PRIMARY_MENU = [
  { key: "home", label: "Home", to: "/", icon: "home" },
  { key: "churches", label: "Churches", to: "/churches", icon: "church" },
  { key: "lists", label: "My Lists", to: "/lists", icon: "lists" },
  { key: "friends", label: "Friends", to: "/friends", icon: "friends" },
  { key: "groups", label: "Circles", to: "/circles", icon: "groups" },
  { key: "search", label: "Search Users", action: "openSearch", icon: "search" },
  INBOX_MENU_ITEM,
];

export const ACCOUNT_MENU_ITEMS = [
  { key: "profile", label: "Profile", to: "/profile" },
  { key: "churches", label: "Churches", to: "/churches" },
  { key: "events", label: "Events", to: "/events" },
  { key: "circles", label: "Circles", to: "/circles" },
  INBOX_MENU_ITEM,
  { key: "settings", label: "Settings", to: "/settings" },
  {
    key: "platformAdmin",
    label: "Platform Admin",
    to: "/admin",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  {
    key: "domainInfrastructure",
    label: "Domain Infrastructure",
    to: "/admin/domain-infrastructure",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  {
    key: "foundingMemberCodes",
    label: "Promo Codes",
    to: "/admin/founding-member-codes",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  {
    key: "prayerTags",
    label: "Prayer Tags",
    to: "/admin/prayer-tags",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  {
    key: "docs",
    label: "About",
    to: "/docs/requirements",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  { key: "logout", label: "Log Out", action: "logout" },
];

export const QUICK_LINKS = [
  { key: "home", label: "Home", to: "/", icon: "home" },
  INBOX_MENU_ITEM,
  { key: "settings", label: "Settings", to: "/settings", icon: "settings" },
  {
    key: "adminOverview",
    label: "Platform Admin",
    to: "/admin",
    icon: "settings",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  {
    key: "designSystem",
    label: "Design System",
    to: "/admin/design-system",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
  {
    key: "adminDocs",
    label: "About",
    to: "/docs/requirements",
    icon: "docs",
    requiredPlatformRole: "GLOBAL_ADMIN",
  },
];

export const SIDEBAR_SECTIONS = {
  churches: { title: "My Churches" },
  groups: { title: "My Circles" },
  lists: { title: "My Lists" },
  friends: { title: "Friends" },
  pendingRequests: { title: "Pending Friend Requests" },
};

export function getUserRoles(user) {
  const roleCandidates = [
    user?.role,
    ...(Array.isArray(user?.roles) ? user.roles : []),
  ].filter(Boolean);

  if (roleCandidates.length === 0) return ["USER"];
  return [...new Set(roleCandidates.map((role) => String(role).toUpperCase()))];
}

export function getPlatformRole(user) {
  const explicitPlatformRole = String(user?.platformRole || "")
    .trim()
    .toUpperCase();

  if (explicitPlatformRole === "GLOBAL_ADMIN") return "GLOBAL_ADMIN";

  const userRoles = getUserRoles(user);
  return userRoles.includes("ADMIN") ? "GLOBAL_ADMIN" : "USER";
}

export function canAccessMenuItem(user, item) {
  const requiredPlatformRole = String(item?.requiredPlatformRole || "")
    .trim()
    .toUpperCase();
  if (requiredPlatformRole && getPlatformRole(user) !== requiredPlatformRole) {
    return false;
  }

  const requiredAnyRole = item?.requiredAnyRole;
  if (!requiredAnyRole || requiredAnyRole.length === 0) return true;

  const userRoles = getUserRoles(user);
  return requiredAnyRole.some((role) =>
    userRoles.includes(String(role).toUpperCase())
  );
}
